import { initGtag } from '@src/telemetry/integrations/GoogleAdsTag'

import { TELEMETRY_DOMAINS } from '../telemetry-domains.constants'
import { TelemetryIntegration } from '../telemetry-events.types'

// Does not load gtag/js here — the GTM container already loads via the
// _document inline snippet (root-layout.helpers.tsx). initGtag() is kept:
// it's idempotent, and is the sole initGtag() caller for countryCompliant
// locales (e.g. UK), where src/telemetry/integrations/GoogleAnalytics4.ts's
// initialize() early-returns.
export const GoogleAnalytics4: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.GOOGLE_TAG_MANAGER,
    featureGateName: 'ssr_telemetry_google_web_container',
  },

  initialize: () => {
    initGtag()
  },

  events: {},
}
